<script setup>
</script>
<template>
    <div>
        <div>
            <span class="h5">{{ label }}</span>
            <b-dropdown
                v-if="book"
                class="float-right"
                size="sm"
                variant="outline-secondary"
            >
                <template #button-content>
                    <font-awesome-icon :icon="['fad', 'cog']" />
                </template>
                <b-dropdown-item :href="book.cdn_url" :disabled="!book.cdn_url" target="_blank">
                    <font-awesome-icon :icon="['fad', 'external-link']" class="text-primary" fixed-width />
                    Open in new tab
                </b-dropdown-item>
                <b-dropdown-item
                    @click="deleteFlipBook"
                    :disabled="disabled || !can_delete_flipbook"
                >
                    <font-awesome-icon :icon="['fad', 'trash']" class="text-danger" fixed-width />
                    Delete
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <b-alert
            v-if="!book"
            variant="warning"
            class="mt-2 mb-0"
            show
        >
            {{ label }} not created.
            <b-btn
                class="float-right"
                size="sm"
                variant="link"
                @click="createFlipBook"
                :disabled="disabled || !can_create_flipbook"
            >
                Create
            </b-btn>
        </b-alert>

        <b-alert
            v-else-if="book && book.status === 'submitted'"
            variant="primary"
            class="mt-2 mb-0"
            show
        >
            {{ label }} submitted for processing.
        </b-alert>

        <b-alert
            v-else-if="book && book.status === 'processing'"
            variant="primary"
            class="mt-2 mb-0"
            show
        >
            <b-spinner small label="Processing..." class="mr-2" />
            {{ label }} in progress.
        </b-alert>

        <b-alert
            v-else-if="book && book.status === 'failed'"
            variant="danger"
            class="mt-2 mb-0"
            show
        >
            {{ label }} failed.
            <b-btn class="float-right" size="sm" variant="link" @click="createFlipBook">
                Retry
            </b-btn>
        </b-alert>

        <div
            v-else-if="book && book.status === 'completed'"
            class="w-100 mt-2"
        >
            <iframe :src="book.cdn_url" width="100%" class="flipbook-iframe" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.flipbook-iframe {
    min-height: 300px;
}
</style>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
    props: {
        label: String,
        type: String,
        book: Object,
        pdf_url: String,
        title: String,
        unit_id: Number,
        disabled: Boolean,
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        can_create_flipbook() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'create_flipbook')
        },
        can_delete_flipbook() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'delete_flipbook')
        },
    },
    methods: {
        async createFlipBook() {
            try {
                if (!this.pdf_url) {
                    await this.$swal({
                        html: `This week does not have a PDF set for ${this.label}. Please add that first.`,
                        confirmButtonText: 'OK',
                        reverseButtons: true
                    })
                    return
                }
                const payload = {
                    'unit_id': this.unit_id,
                    'type': this.type,
                    'url': this.pdf_url,
                    'title': this.title,
                }
                const {data} = await this.axios.post('/api/flipbook', payload)
                this.$emit('created', data)
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to create Flip Book: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
        async deleteFlipBook() {
            const result = await this.$swal({
                html: 'Are you sure you want to delete this Flip Book?',
                showCancelButton: true,
                confirmButtonText: `Delete ${this.label}`,
                confirmButtonColor: '#E74C3C',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })
            if (!result.value) {
                return
            }

            try {
                await this.axios.delete(`/api/flipbook/${this.book.id}`)
                this.$emit('deleted', this.book)
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to delete Flip Book: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
    },
}
</script>
